import axios from "../helpers/axios-auth"

class ProductService {

    getProducts(filterParams, page, size, sort) {

        if (!page) page = 0;
        else page -= 1;

        if (!size) size = 50;

        let params = { page, size, sort };

        if (filterParams.name)
            params["name"] = filterParams.name;

        if (filterParams.code)
            params["code"] = filterParams.code;

        if (filterParams.status)
            params["status"] = filterParams.status;

        if (filterParams.unitId)
            params["unitId"] = filterParams.unitId;

        if (filterParams.brandId)
            params["brandId"] = filterParams.brandId;

        if (filterParams.categoryId)
            params["categoryId"] = filterParams.categoryId;

        if (filterParams.registerId)
            params["registerId"] = filterParams.registerId;

        if (filterParams.isSpecialOffer)
            params["isSpecialOffer"] = filterParams.isSpecialOffer;

        if (filterParams.isPromo)
            params["isPromo"] = filterParams.isPromo;

        return axios.get("/products", { params })
    }

    getProductDetail(id) {
        return axios.get(`/product/${id}`)
    }

    getCategories(shopId = "") {
        return axios.get(`/categories-by-status/ACTIVE?registerId=${shopId}`)
    }

    getBrands(shopId = "") {
        return axios.get(`/brands-by-status/ACTIVE?registerId=${shopId}`)
    }

    getUnits(shopId = '') {
        return axios.get(`/units-by-status/ACTIVE?registerId=${shopId}`)
    }

    getAllProductByPavilion(filterParams, page, size) {
        if (!page) page = 0
        else page -= 1

        if (!size) size = 50

        let params = { page, size }

        if (filterParams.slugName) params['slugName'] = filterParams.slugName

        return axios.get('/all-product-by-pavilion', { params })
    }

    getProductFav(id) {
        return axios.get('/auth/product-fav/' + id);
    }
}

export default new ProductService()
